/** @format */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { SimCardServiceTypeAllowedParamCollection, SimCardServiceTypeItem } from '../../../../interfaces/collections/SimCardServiceInterface';
import CardHeader from '../../../../components/Heading/CardHeaderExt';
import { Build } from '@material-ui/icons';
import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { FeaturesServiceReducerType, ServicesAction } from '../../../../modules/features/FeaturesReducers';
import { ServicesMvneType } from '../../../../modules/lib/hooks/useOperatorType';
import { OplSimCardServiceTypeBmeParam } from './OplSimCardServiceTypeBmeParam';

type OplSimCardServiceTypeBmeParamsType = {
    simCardServiceType: SimCardServiceTypeItem;
};

export const OplSimCardServiceTypeBmeParams: FunctionComponent<OplSimCardServiceTypeBmeParamsType> = ({ simCardServiceType }): React.ReactElement => {
    const dispatch = useDispatch();
    const [allowedParamsList, setAllowedParamsList] = useState<SimCardServiceTypeAllowedParamCollection | null>(null);
    const loadAllowedParams = useCallback(() => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_type_allowed_params')),
            'get_sim_card_service_type_allowed_params',
            [{ name: 'serviceType', value: ServicesMvneType.BME }],
            [{ name: 'operationVerbId', value: 'asc' }],
            (data: SimCardServiceTypeAllowedParamCollection) => {
                setAllowedParamsList(data);
                dispatch({
                    type: ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_LIST,
                    simCardServiceTypeAllowedParamsCollection: data,
                } as FeaturesServiceReducerType);
            },
            { dispatchAfterCallback: false, propagateDataToCallback: true }
        );
    }, [dispatch]);

    useEffect(() => {
        if (!allowedParamsList) {
            loadAllowedParams();
        }
    }, [allowedParamsList, loadAllowedParams]);

    return (
        <Card>
            <CardHeader icon={<Build />} trans="prov:feature.bme_component_params" />
            <CardBody>
                {allowedParamsList &&
                    allowedParamsList['hydra:member'].map((item) => {
                        return <OplSimCardServiceTypeBmeParam key={item.id} param={item} id={item.id} />;
                    })}
            </CardBody>
        </Card>
    );
};
